import { sceneHelper } from '../helper/scene-helper';
import { readObjectRefId } from '../helper/object-ref';
import { applyObjectVisibility } from '../helper/visibility-helper';

export async function runSetVisibleImplementation(
  data: { target?: unknown; visible: boolean },
  _nodeId: string
) {
  const targetId = readObjectRefId(data.target);
  if (!targetId) throw new Error('no target object is set on this node');

  const object = sceneHelper?.getObjectByUUID(targetId);
  if (!object) {
    console.error(`Object ${targetId} not found`);
    return;
  }

  applyObjectVisibility(object, data.visible);
}
